<script>
    export default {
        name: "MediaCardLink",
        props: {
            url: String,
        },
        computed: {
            resource() {
                return new URL(this.url).hostname;
            },
        },
    };
</script>

<template>
    <div class="media-card__link">{{ resource }}</div>
</template>

<style lang="scss">
    .media-card__link {
        font-size: 14px;
        color: var(--media-source);
    }
</style>
